export default "__VITE_ASSET__BTsS_bIO__"